import React, { memo } from "react";
import { Trans, useTranslation } from "react-i18next";
import { JobLocationFormater } from "../formater/jobLocationFormater";
import { LikeOffreEmploi } from "../likeoffreemploi/likeoffreemploi";
import { Link, useHistory } from "react-router-dom";
import { Button } from "primereact/button";
import { DurationFormater } from "../formater/durationFormater";
import { DipTag } from "../tag/dipTag";
import "./offreEmploiThumbnail.css";

const OffreEmploiThumbnailComponent = (props) => {

    const {t} = useTranslation();
    const history = useHistory();

    const renderTypeContrat = () => {
        if (props.offreEmploi.alternance) {
            return <DipTag className="dip-tag-orange dip-tag-p-sm"label={t('offers.alternance')} />;
        }
        else if (props.offreEmploi.natureContrat?.code == "ST") {
            return <DipTag className="dip-tag-orange dip-tag-p-sm" label={t('offers.traineeship')}/>;
        } else if (props.offreEmploi.natureContrat?.code == "E1") {
            if (props.offreEmploi.typeContrat?.code == "CDI") {
                return <DipTag className="dip-tag-orange dip-tag-p-sm" label={"CDI"}/>
            }
            else {
                return <DipTag className="dip-tag-orange dip-tag-p-sm" label={"CDD"}/>;
            }
        }
        else {
            return <span></span>
        }
    }

    return (
        <div className="oet-offre-emploi-card">
            <div className="oet-card-header">
                <div className="oet-title-and-heart">
                    <h3 className="oet-job-title" title={props.offreEmploi.intitule}>{props.offreEmploi.intitule}</h3>
                    <LikeOffreEmploi offreEmploi={props.offreEmploi} onUnlike={props.onUnlike} toast={props.toast} />
                </div>
                <div className="oet-contract-tag">
                    {renderTypeContrat()}
                </div>
            </div>
            
            <div className="oet-card-body">
                <div className="oet-company-name" title={props.offreEmploi?.entreprisePoleEmploi?.nom || props.offreEmploi.entreprise?.nomEntreprise}>{props.offreEmploi?.entreprisePoleEmploi?.nom || props.offreEmploi.entreprise?.nomEntreprise}</div>
                
                <div className="oet-job-details">
                    <div className="oet-detail-item">
                        <i className="pi pi-map-marker" />
                        <span>{props.offreEmploi.providerId === 2 ? <JobLocationFormater offreEmploi={props.offreEmploi} /> : props.offreEmploi.lieuTravail.libelle}</span>
                    </div>
                    
                    <DurationFormater offreEmploi={props.offreEmploi} />
                </div>
                
                <div className="oet-publish-date">
                    <Trans i18nKey="offers.published_on" values={{date:props.offreEmploi.dateCreation}} />
                </div>
            </div>
            
            <div className="oet-card-footer">
                <Link to={{pathname: '/vueOffreEmploi', search: `?offreEmploiId=${props.offreEmploi.id}`, state: {pageProfil: props.urlPagination?.profil, pageFormation: props.urlPagination?.formation, pageFavorites: props.urlPagination?.favorites}}}>
                    <Button className="oet-consult-button">
                        <span>{t('general.see_offer')}</span>
                        <i className="pi pi-arrow-right oet-button-icon"></i>
                    </Button>
                </Link>
            </div>
        </div>
    );
}

// Memoizing the component to avoid unnecessary re-renders
export const OffreEmploiThumbnail = memo(OffreEmploiThumbnailComponent, (prevProps, nextProps) => {
    // Re-render only if the offer or onUnlike changes
    return prevProps.offreEmploi.id === nextProps.offreEmploi.id &&
           prevProps.offreEmploi.liked === nextProps.offreEmploi.liked &&
           prevProps.offreEmploi.dateCreation === nextProps.offreEmploi.dateCreation;
});